const columns = [
  {
    name: 'Name',
    selector: (row) => row.attributes.full_name,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Work Email',
    selector: (row) => row.attributes.email,
    cell: (row) => (
      `${row.attributes.email}${row.attributes.possible_invite ? '' : ' (Scheduled)'}`
    ),
    sortable: true,
    searchable: true,
  },
  {
    name: 'Team',
    selector: (row) => row.attributes.team,
    sortable: true,
  },
  {
    name: 'Program',
    selector: (row) => row.attributes.programs.map((program) => program.title).join(', '),
    sortable: true,
  },
];

export default columns;
